import React, { Fragment, useEffect } from 'react'
import { useUser } from '../../hooks/useUser'
import { useUserProfile } from '../../hooks/useUserProfile'
import { useAuth } from 'oidc-react'

export const UserProvider: React.FC<any> = ({ children }) => {
  const { getUserData } = useUser()
  const { setUserProfile } = useUserProfile()

  const auth = useAuth()

  useEffect(() => {
    setUserProfile(auth.userData?.profile)
  }, [])

  useEffect(() => {
    getUserData()
  }, [])
  return <Fragment>{children}</Fragment>
}
